// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"201":"9d4a0867","265":"8a032738","490":"fe8bd794"}[chunkId] + ".chunk.js";
};